import { classNames } from '@dimjs/utils';
import { ReactNode, useContext } from 'react';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import { StickyContext } from './context';

export type StickyItemProps = {
  stickyKey: string;
  title: ReactNode;
} & CommonPropsWithChildren;

export const StickyItem = (props: StickyItemProps) => {
  const context = useContext(StickyContext);
  return withNativeProps(
    props,
    <div
      className={classNames('v-sticky-item', {
        'v-sticky-item-active': context.activeKey === props.stickyKey,
      })}
      data-index={props.stickyKey}
    >
      <div className="v-sticky-item-title" data-index={props.stickyKey}>
        {props.title}
      </div>
      {props.children}
    </div>,
  );
};
